<script setup lang="ts">
import {defineEmits, getCurrentInstance, reactive, ref} from "vue";
import Stay from "@/models/Stay";
import * as dayjs from 'dayjs'
import {useStore} from "vuex";
import LoadingSpinner from "@/shared/components/loading/LoadingSpinner.vue";
  const { $alert } = getCurrentInstance().appContext.config.globalProperties;
  const { $axios } = getCurrentInstance().appContext.config.globalProperties;
  const { $endpoint } = getCurrentInstance().appContext.config.globalProperties;
  const stayType = ref([])
  const paymentType = ref([])
const store = useStore()
const emit = defineEmits(['stayInfosSave'])

const bookDateDatas = store.getters['booking_filter/getRoomFilter']
const roomDatas = store.getters['room/getRoomChoose']
const stayOldData = store.getters['booking/getStay']
const stayForm = reactive<Stay>({
  stays_enter_date:bookDateDatas.arrival,
  stays_leaving_date:bookDateDatas.departure,
  customer_id:0,
  stay_type:stayOldData ==null?null:stayOldData.stay_type,
  stays_date:new Date(),
  is_booking: true,
  room_id:roomDatas.id,
  stays_number_of_children:0,
  stays_number_of_days:0,
  stays_number_of_occupants:bookDateDatas.guest,
  stays_preference:stayOldData ==null?'':stayOldData.stays_preference,
  stays_pay_off:false,
  stays_remaining_amount:0,
  stays_status:250,
  stays_vat:0,
  stays_total_price_to_pay:0,
  pay_mode:stayOldData ==null?'':stayOldData.pay_mode
})
const load = ref(false)
const isBooking = (arrival:Date)=>{
    const arrivalDate = dayjs(arrival)
    const dateNow = dayjs()
  return arrivalDate.isAfter(dateNow)
}

const getDaysNumber = (arrival:Date, departure:Date) => {
    const arrivalDate = dayjs(arrival)
    const departureDate = dayjs(departure)
  console.log(departureDate.diff(arrivalDate,'day',true))
  return departureDate.diff(arrivalDate,'day')
}
  $axios.get($endpoint.LoadStayType).then((res_type:any)=>{
    stayType.value = res_type.data
  })
  $axios.get($endpoint.LoadPaymentType).then((res_type:any)=>{
    paymentType.value = res_type.data
  })
const stayValidator = ()=>{
    return stayForm.stays_preference==''
        ||stayForm.stay_type==null
        ||stayForm.pay_mode==''
}
const calculStay =()=>{
    if (stayValidator()){
      $alert.fire({
        title: 'Ooops!',
        text: "Veuillez renseigné tout les champs",
        icon: 'error',
        confirmButtonColor:'#D62F2F',
        confirmButtonText: 'Compris'
      })

    }else {
      load.value = true
      stayForm.is_booking = isBooking(stayForm.stays_enter_date)
      stayForm.stays_number_of_days = getDaysNumber(stayForm.stays_enter_date,stayForm.stays_leaving_date)
      stayForm.stays_total_price_to_pay = stayForm.stays_number_of_days * roomDatas.room_total_price
      stayForm.stays_remaining_amount = stayForm.stays_total_price_to_pay
      store.dispatch('booking/saveStayData', stayForm)
      setTimeout(()=>{
        load.value =false

      },1000)
      emit('stayInfosSave')
      console.warn(stayForm)
    }
}

</script>

<template>
  <div class="uk-container-large uk-margin-top border-outline">
    <loading-spinner v-if="load"></loading-spinner>
    <h6 class="uk-heading-line uk-text-center uk-text-secondary uk-text-uppercase uk-text-bold"><span>Merci de compléter les informations concernant le séjour.</span></h6>
    <form class="uk-grid-small" data-uk-grid>
      <div class="uk-margin uk-width-1-1@s uk-width-1-2@l uk-width-1-2@xl uk-form-controls">
        <div class="uk-inline uk-margin-top">
          <label class="uk-form-label" for="form-horizontal-text">Type de séjour*</label>
          <select v-model="stayForm.stay_type" class="uk-select uk-input uk-form-width-large uk-border-rounded csa-input">
            <option v-for="stay_type in stayType" :value="stay_type" :key="stay_type.id">{{stay_type.stay_typ_name}}</option>
          </select>
        </div>
      </div>
      <div class="uk-margin uk-width-1-1@s uk-width-1-2@l uk-width-1-2@xl uk-form-controls">
        <div class="uk-inline ">
          <label class="uk-form-label" for="form-horizontal-text">Mode de paiement*</label>
          <select v-model="stayForm.pay_mode" class="uk-select uk-input uk-form-width-large uk-border-rounded csa-input">
            <option v-for="pay_type in paymentType" :value="pay_type.pay_typ_name" :key="pay_type.id">{{pay_type.pay_typ_name}}</option>
          </select>
        </div>
      </div>
      <div class="uk-margin uk-width-1-1@s uk-width-1-2@l uk-width-1-2@xl uk-form-controls">
        <div class="uk-inline">
          <span class="uk-form-icon uk-form-icon-flip" uk-icon="icon: users"></span>
          <input v-model="stayForm.stays_number_of_children" class="uk-input uk-input uk-form-width-large uk-border-rounded csa-input" placeholder="Nombre d'enfant(s)" type="number"  aria-label="Not clickable icon">
        </div>
      </div>

<!--      <div class="uk-margin uk-width-1-1@s uk-width-1-2@l uk-width-1-2@xl uk-form-controls">-->
<!--        <div class="uk-inline">-->
<!--          <span class="uk-form-icon uk-form-icon-flip" uk-icon="icon: cart"></span>-->
<!--          <input class="uk-input uk-input uk-form-width-large uk-border-rounded csa-input" placeholder="Code de reduction si possible" type="text" aria-label="Not clickable icon">-->
<!--        </div>-->
<!--      </div>-->
      <div class="uk-margin uk-width-1-1@s uk-width-1-1@l uk-width-1-1@xl uk-form-controls">
        <label class="uk-form-label" for="form-horizontal-text">Préférence/Note</label>

          <textarea v-model="stayForm.stays_preference" class="uk-textarea uk-border-rounded csa-input" rows="5" placeholder="Préférence ou Note: Allergies, motricité, repas" aria-label="Textarea"></textarea>
      </div>

      <button type="button" class="uk-button uk-button-large csa-btn uk-margin-left uk-text-center" @click="calculStay()">Valider</button>
    </form>

  </div>
</template>

<style scoped>

</style>